// extracted by mini-css-extract-plugin
export default {"wlarge":"Members_wlarge__NvepK","wsmall":"Members_wsmall__L5Sh+"};